import { create } from "zustand";
import type { IVendor } from "../types/models/vendor.modals.types";

interface IVendorsStore {
  data: IVendor[] | null;
  setData: (data: IVendor[] | null) => void;
  addVendor: (data: IVendor) => void;
}

const useVendorsStore = create<IVendorsStore>((set) => ({
  data: null,
  setData: (data: IVendor[] | null) => set(() => ({ data })),
  addVendor: (data: IVendor) => {
    set((state) => ({ 
    data: state.data ? [data, ...state.data] : [data] 
    }));
  },
}));

export default useVendorsStore;
